import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="18" cy="18" r="11" stroke="#DF723A" strokeWidth="2" /><path fillRule="evenodd" clipRule="evenodd" d="M18 20a1 1 0 01-1-1v-6a1 1 0 112 0v6a1 1 0 01-1 1zM18 24a1 1 0 110-2 1 1 0 010 2z" fill="#DF723A" /></svg>);